import app from "./../app";

app.socketNotify.on('notify:processingOrder', function (data) {
  app.trigger('notify:payment:orderProcessing', data);
  app.trigger('paymentPlanInfo:hide');
  app.trigger('btnUpgrade:hide');
});

app.socketNotify.on('notify:orderCharged', function (data) {
  app.trigger('notify:payment:orderFilled', data);
});

app.socketNotify.on('notify:orderDeclined', function (data) {
  app.trigger('notify:payment:orderFailed', data);
});

